window.addEventListener('load', () => {
    const bg_moving = document.querySelector(".MovingBackgroundComponent");
    if (!bg_moving)
        return;
    const module = import('./bg-moving');
    module.then((mod) => mod.default());
});
